import React, { useState, useEffect } from "react"
import { PaginationItem, PaginationLink, Pagination } from "reactstrap"
import "./style.css"

const MyGrid = ({
  columns,
  data,
  config = {},
  initLengFilter,
  funtions,
  optionsSelect,
  theme,
}) => {
  const {
    tree,
    treeColumns,
    nodeTreeData,
    fileName,
    exportFile,
    width,
  } = config
  const [rowsValues, setRowsValues] = useState([])
  const [queryFilter, setQueryFilter] = useState({})
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [pagsel, setPage] = useState(1)

  //values form
  //efecto de inicio
  useEffect(() => {
    setRowsValues(data)
  }, [])

  //efecto de queryFilter
  useEffect(() => {
    if (data) {
      let results = data.filter((item) => {
        if (Object.keys(queryFilter).length > 0) {
          let queryStr = ""
          for (let key in queryFilter) {
            if (queryFilter[key]) {
              queryStr += `'${item[key]}'.toString()
              .toLowerCase()
              .indexOf('${queryFilter[key]}'.toString().toLowerCase()) > -1 && `
            }
          }
          if (queryStr.length > 0) {
            if (eval(queryStr.substring(0, queryStr.length - 3))) {
              item.expandable = false
              return item
            }
          } else {
            return item
          }
        } else {
          return item
        }
      })

      setRowsValues(results)
    }
  }, [queryFilter])

  const setHeaders = (header) => {
    if (!header) return null
    return header
      .filter((item) => item.visible === true)
      .map((item, index) => {
        const { styleTable } = item
        let styleConfig = null
        if (styleTable) {
          styleConfig = styleTable.header
            ? {
                backgroundColor: styleTable.header.bgColor,
                width: styleTable.header
                  ? styleTable.header.width
                    ? styleTable.header.width
                    : "auto"
                  : "auto",
              }
            : null
        }

        return (
          <th key={index} className={"header-text"} style={styleConfig}>
            {item.text}
          </th>
        )
      })
  }

  const setFilters = (header) => {
    if (!header) return null

    return header
      .filter((item) => item.visible === true)
      .map((item, index) => {
        const { styleTable } = item
        let styleConfig = null
        if (styleTable) {
          styleConfig = styleTable.header
            ? { backgroundColor: styleTable.header.bgColor }
            : null
        }

        return item.filter ? (
          <th key={index} className={"filter-input"} style={styleConfig}>
            <input
              type={"text"}
              className={"input-fiter"}
              placeholder={`Buscar por ${item.text.toLowerCase()}`}
              onChange={(e) => {
                let value = e.target.value
                const newFilter = { ...queryFilter }
                if (value.length > initLengFilter) {
                  newFilter[item.field] = e.target.value
                  setQueryFilter(newFilter)
                } else {
                  newFilter[item.field] = null
                  setQueryFilter(newFilter)
                }
              }}
            />
          </th>
        ) : (
          <th key={index} className={"header-text"} style={styleConfig} />
        )
      })
  }

  const expandable = (obj, indice) => {
    let findIndex = rowsValues.findIndex((item) => item === obj)
    const newStateRows = [...rowsValues]
    newStateRows[findIndex].expandable = !newStateRows[findIndex].expandable
    setRowsValues(newStateRows)
  }

  const exporFile = () => {
    let uri = "data:application/vnd.ms-excel;base64,",
      template =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      },
      format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p]
        })
      },
      tableToExcel = "<table border=1>"
    tableToExcel += "<thead>"
    tableToExcel += "<tr>"
    for (let index = 0; index < columns.length; index++) {
      try {
        if (columns[index].visible) {
          const {
            styleExcel: { header },
          } = columns[index]
          tableToExcel += `<th style="border:${
            header ? header.border : "none"
          }px; background: ${header ? header.bgColor : "#21282e"}; color: ${
            header ? header.color : "black"
          }; font-size: ${header ? header.fontSize : "10px"}">${
            columns[index].text
          }</th>`
        }
      } catch (err) {
        console.error(err)
      }
    }
    tableToExcel += "</tr>"
    tableToExcel += "</thead>"
    tableToExcel += "<tbody>"

    for (let index = 0; index < rowsValues.length; index++) {
      let nodeChild = rowsValues[index][nodeTreeData]
      tableToExcel += "<tr>"
      for (let a = 0; a < columns.length; a++) {
        try {
          if (columns[a].visible) {
            const {
              styleExcel: { body },
            } = columns[a]
            const { parseValueExcel } = columns[a]
            let textRender = parseValueExcel
              ? parseValueExcel(
                  rowsValues[index][columns[a].field],
                  rowsValues[index]
                )
              : rowsValues[index][columns[a].field] != null
              ? rowsValues[index][columns[a].field]
              : ""
            tableToExcel += `<td style="border:${body.border}px; background: ${body.bgColor}; color: ${body.color}; font-size: ${body.fontSize}">${textRender}</td>`
          }
        } catch (err) {}
      }
      tableToExcel += "</tr>"
      if (tree) {
        tableToExcel += "<tr>"
        tableToExcel += `<td colspan=${
          columns.filter((item) => item.visible === true).length
        }>`
        tableToExcel += "<table>"
        tableToExcel += "<thead>"
        tableToExcel += "<tr>"
        tableToExcel += "<th></th>"
        for (let index = 0; index < treeColumns.length; index++) {
          try {
            const element = treeColumns[index]
            if (element.visible) {
              const {
                styleExcel: { header },
              } = element
              tableToExcel += `<th style="border:${
                header ? header.border : "none"
              }px; background: ${header ? header.bgColor : "#21282e"}; color: ${
                header ? header.color : "#000000"
              }; font-size: ${header ? header.fontSize : "10"}px">${
                element.text
              }</th>`
            }
          } catch (err) {}
        }
        tableToExcel += "<tbody>"
        for (let b = 0; b < nodeChild.length; b++) {
          tableToExcel += "<tr>"
          tableToExcel += "<td></td>"
          for (let c = 0; c < treeColumns.length; c++) {
            try {
              if (treeColumns[c].visible) {
                try {
                  const {
                    styleExcel: { body },
                  } = treeColumns[c]
                  const { parseValueExcel } = treeColumns[c]
                  let text = parseValueExcel
                    ? parseValueExcel(
                        nodeChild[b][treeColumns[c].field],
                        nodeChild[b]
                      )
                    : nodeChild[b][treeColumns[c].field]
                    ? nodeChild[b][treeColumns[c].field]
                    : ""

                  tableToExcel += `<td style="border:${body.border}px; background: ${body.bgColor}; color: ${body.color}; font-size: ${body.fontSize}px">${text}</td>`
                } catch (ex) {}
              }
            } catch (err) {
              console.error(err)
            }
          }
          tableToExcel += "</tr>"
        }
        tableToExcel += "</tr>"
        tableToExcel += "</thead>"
        tableToExcel += "</table>"
        tableToExcel += "</td>"
        tableToExcel += "</tr>"
      }
    }

    tableToExcel += "</tbody>"
    tableToExcel += "</table>"

    let ctx = { worksheet: fileName || "Worksheet", table: tableToExcel }
    let link = document.createElement("a")
    link.href = uri + base64(format(template, ctx))
    link.download = `${fileName}.xls`
    link.click()
  }

  const setBody = () => {
    if (!rowsValues) return null
    return rowsValues
      .slice(
        (pagsel - 1) * rowsPerPage,
        (pagsel - 1) * rowsPerPage + rowsPerPage
      )
      .map((item, index) => {
        let existChild = item[nodeTreeData] ? true : false
        let randoIndex = Math.floor(Math.random() * (100 - 1 + 1)) + 1
        return (
          <>
            <tr key={index}>
              {existChild ? (
                <td className={"body-text"}>
                  <button
                    className="expandable-btn"
                    onClick={() => expandable(item, index)}>
                    {item.expandable
                      ? item.expandable
                        ? "\u2B9F"
                        : "\u2B9E"
                      : "\u2B9E"}
                  </button>
                </td>
              ) : tree ? (
                <td />
              ) : null}
              {setTd(item, columns)}
            </tr>
            {tree && existChild && item.expandable ? (
              <tr key={`${randoIndex}_${index}`}>
                <td
                  colSpan={Object.keys(item).length}
                  className={"body-text openChild "}>
                  <table className={"subGrid"}>
                    <thead>{setHeaders(treeColumns)}</thead>
                    <tbody>{setBodyTree(item[nodeTreeData], index)}</tbody>
                  </table>
                </td>
              </tr>
            ) : null}
          </>
        )
      })
  }

  const setBodyTree = (child, indexChild) => {
    if (!child) return null
    return child.map((item, index) => {
      return (
        <tr key={index}>{setTd(item, treeColumns, [indexChild, index])}</tr>
      )
    })
  }

  const setTd = (row, keys, indexArr = null) => {
    return keys
      .filter((item) => item.visible === true)
      .map((item, index) => {
        const { styleTable, cCssTr } = item
        let styleTd = null
        if (styleTable) {
          styleTd = styleTable.body
            ? { fontSize: styleTable.body.fontSize }
            : null
        }
        let cssApply = {}
        if (cCssTr) {
          cssApply = cCssTr(row)
        }
        return (
          <td key={index} className={`body-text ${cssApply}`} style={styleTd}>
            {generaTd(row, item, indexArr)}
          </td>
        )
      })
  }

  const generaTd = (row, key, index = null) => {
    switch (key.type) {
      case "button": {
        const {
          iconImg,
          text,
          action,
          hiddenBtn,
          styleIcon,
          tooltip,
          renderCell,
        } = key
        if (hiddenBtn && hiddenBtn(row)) {
          return null
        } else if (renderCell) {
          return renderCell(index, styleIcon, funtions[action], row)
        } else {
          if (tooltip) {
            let idTooltip = `${Math.floor(Math.random() * (100 - 1)) + 1}_${
              Math.floor(Math.random() * (500 - 1)) + 1
            }`
            return (
              <button
                className={"btn-grid"}
                onClick={(e) => {
                  try {
                    funtions[action](row)
                  } catch (err) {}
                }}>
                {iconImg ? (
                  <img alt="#" src={iconImg} style={styleIcon} />
                ) : (
                  text
                )}
              </button>
            )
          } else {
            return (
              <button
                className={"btn-grid"}
                onClick={(e) => {
                  try {
                    funtions[action](row)
                  } catch (err) {}
                }}>
                {iconImg ? (
                  <img alt="#" src={iconImg} style={styleIcon} />
                ) : (
                  text
                )}
              </button>
            )
          }
        }
      }
      case "select": {
        const { inputConfig } = key
        const {
          options,
          propertyOptions,
          idInput,
          renderNotInput,
        } = inputConfig
        let textRender = null
        if (renderNotInput) textRender = renderNotInput(row)
        if (textRender) return textRender
        return (
          <select
            key={index}
            defaultValue={row[key.field]}
            className={row[idInput]}
            field={key.field}>
            <option value="">Seleciona una opción</option>
            {optionsSelect[options].map((item, ii) => (
              <option key={ii} value={item[propertyOptions.value]}>
                {item[propertyOptions.text]}
              </option>
            ))}
          </select>
        )
      }
      case "textArea": {
        const { inputConfig } = key
        const { idInput, renderNotInput } = inputConfig
        let textRender = null
        if (renderNotInput) textRender = renderNotInput(row)
        if (textRender) return textRender
        return (
          <input
            type={"text"}
            key={index}
            defaultValue={row[key.field]}
            className={row[idInput]}
            field={key.field}
          />
        )
      }
      default: {
        const { parseValue, functionBtn, renderCell } = key
        let render = renderCell
          ? renderCell(row[key.field], funtions[functionBtn])
          : null
        let text = parseValue ? parseValue(row[key.field], row) : row[key.field]
        let btn =
          functionBtn && (render === null || render === undefined) ? (
            <button
              className={"btn-row"}
              onClick={() =>
                funtions[functionBtn]({ data: row, key: key.field })
              }>
              {text}
            </button>
          ) : renderCell ? (
            render
          ) : (
            text
          )

        return btn
      }
    }
  }

  const handleChangePage = (newPage) => {
    setPage(newPage)
  }

  const generaPaginacion = (pagesCount) => {
    let numberPage = [],
      minPage = pagsel - 1,
      maxPage = pagsel + 5 < pagesCount ? pagsel + 5 : pagesCount
    for (let index = minPage; index <= maxPage; index++) {
      numberPage.push(
        <PaginationItem key={index} active={pagsel === index + 1}>
          <PaginationLink
            onClick={(e) => handleChangePage(index + 1)}
            style={theme && theme.pagination ? theme.pagination : null}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>
      )
    }
    return numberPage
  }

  const setPagination = () => {
    if (!rowsValues) return null
    const contPagination = Math.floor(rowsValues.length / rowsPerPage)
    return (
      <Pagination aria-label="Page navigation example">
        <PaginationItem disabled={pagsel <= 1}>
          <PaginationLink onClick={(e) => handleChangePage(1)} first />
        </PaginationItem>
        <PaginationItem disabled={pagsel <= 1}>
          <PaginationLink
            onClick={(e) => handleChangePage(pagsel - 1)}
            previous
          />
        </PaginationItem>
        {generaPaginacion(contPagination)}
        <PaginationItem disabled={pagsel >= contPagination}>
          <PaginationLink onClick={(e) => handleChangePage(pagsel + 1)} next />
        </PaginationItem>
        <PaginationItem disabled={pagsel >= contPagination}>
          <PaginationLink
            onClick={(e) => handleChangePage(contPagination)}
            last
          />
        </PaginationItem>
      </Pagination>
    )
  }

  const contraerFunc = () => {
    let opens = rowsValues.filter((item) => item.expandable === true).length
    return opens ? (
      <button
        className={"btn-contraer"}
        onClick={() => {
          const newRows = rowsValues.map((item) => {
            item.expandable = false
            return item
          })

          setRowsValues(newRows)
        }}>
        <img
          alt=""
          src={`${process.env.PUBLIC_URL}/recursos/contract-arrows.png`}
        />
      </button>
    ) : null
  }

  return (
    <div
      className={"Container-Grid"}
      style={{
        overflowX: config.scrollX ? "scroll" : "none",
      }}>
      <div className={"pagination"}>
        <div className={"btn-paginations"}>{setPagination()}</div>
        <div className={"btn-rowsOfPages"}>
          <div>
            {exportFile ? (
              <button onClick={() => exporFile()} className={"btn-excel"}>
                <img
                  src={`${process.env.PUBLIC_URL}/recursos/icono_excel.png`}
                  alt="No"
                />
              </button>
            ) : null}
          </div>
          <div>
            <label className={"lbl-rows"}>Registros por pagina</label>
            <select
              onChange={(e) => {
                setPage(1)
                setRowsPerPage(parseInt(e.target.value))
              }}>
              {[10, 20, 30, 40, 50, 100].map((item, index) => (
                <option value={item} key={index}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <table
        className={"GridTable"}
        id="TableID"
        style={{ width: width ? width : "99%" }}>
        <thead>
          <tr key={"head"}>
            {tree ? (
              <th className={"header-text"} key={"-0-"}>
                {contraerFunc()}
              </th>
            ) : null}
            {setHeaders(columns)}
          </tr>
          <tr key={"filt"}>
            {tree ? <th className={"header-text"} key={"0-"} /> : null}
            {setFilters(columns)}{" "}
          </tr>
        </thead>
        <tbody>{setBody()}</tbody>
      </table>
    </div>
  )
}
export default MyGrid
